import { motion } from "framer-motion";
import { Zap, Clock, Infinity, MousePointer, CreditCard, Shield } from "lucide-react";

const benefits = [
  {
    icon: Zap,
    title: "Fácil de usar",
    description: "Interface intuitiva que permite criar eventos em minutos, sem complicação técnica.",
  },
  {
    icon: Clock,
    title: "Receba rápido",
    description: "Receba suas vendas em até 2 dias úteis após a realização do evento.",
  },
  {
    icon: Infinity,
    title: "Eventos ilimitados",
    description: "Crie quantos eventos quiser, sem limite de quantidade ou tamanho.",
  },
  {
    icon: MousePointer,
    title: "Mapa de assentos",
    description: "Editor visual drag & drop para criar mapas de assentos personalizados.",
  },
  {
    icon: CreditCard,
    title: "Taxas justas",
    description: "Apenas 8% de taxa sobre vendas. Sem custos ocultos ou surpresas.",
  },
  {
    icon: Shield,
    title: "Seguro e confiável",
    description: "Pagamentos processados com segurança e suporte dedicado para você.",
  },
];

export function BenefitsSection() {
  return (
    <section className="py-24 lg:py-32 bg-card relative overflow-hidden">
      {/* Decorative element */}
      <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-wine/[0.02] rounded-bl-[100px]" />
      
      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto mb-16"
        >
          <h2 className="font-heading text-3xl md:text-4xl font-bold mb-4">
            Tudo que você precisa para{" "}
            <span className="text-wine-gradient">vender mais</span>
          </h2>
          <p className="text-muted-foreground text-lg">
            Recursos pensados para facilitar sua vida e maximizar suas vendas.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <motion.div
              key={benefit.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group"
            >
              <div className="card-elevated h-full">
                <div className="w-14 h-14 rounded-xl bg-wine/10 flex items-center justify-center mb-6 group-hover:bg-wine-gradient transition-all duration-300">
                  <benefit.icon 
                    size={28} 
                    className="text-wine group-hover:text-white transition-colors duration-300" 
                  />
                </div>
                <h3 className="font-heading font-semibold text-xl mb-3">
                  {benefit.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
